// src/pages/currencies/EditCurrency.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCurrencies from "../../components/currencies/FormAddEditCurrencies";
import useGetCurrency from "../../hooks/currencies/useGetCurrency";
import LoadingPage from "../../components/global/LoadingPage";

const EditCurrency = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, currency } = useGetCurrency(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/currencies");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCurrencies
                isEdit={true}
                currentData={currency}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditCurrency;
